export default __webpack_public_path__ + "static/media/RiskScore.ff82fa28.svg";